"use client";

type EmojiIconProps = {
  emoji: string;
  size?: number;
  className?: string;
  title?: string;
};

function emojiToTwemojiCodepoint(emoji: string): string {
  // Twemoji expects lower-case hex codepoints joined with '-'
  // e.g. 🇺🇦 => "1f1fa-1f1e6", 🌐 => "1f310", 🏳️‍⚧️ => "1f3f3-fe0f-200d-26a7-fe0f"
  const parts: string[] = [];
  for (const ch of emoji) {
    const cp = ch.codePointAt(0);
    if (cp == null) continue;
    parts.push(cp.toString(16));
  }
  return parts.join("-");
}

export function EmojiIcon({
  emoji,
  size = 16,
  className,
  title,
}: EmojiIconProps) {
  const codepoint = emojiToTwemojiCodepoint(emoji);
  const src = `https://twemoji.maxcdn.com/v/latest/svg/${codepoint}.svg`;

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      width={size}
      height={size}
      alt={emoji}
      title={title}
      className={className}
      style={{ display: "inline-block", verticalAlign: "-0.15em" }}
      loading="lazy"
      decoding="async"
    />
  );
}
